var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@marketing/components/global/CTA/Button';
import MenuItemList from '@marketing/components/navigation/MenuItemList';
import { Link } from 'react-router';
import NavigationLink from '../NavigationLink';
import { sendGoogleTagManagerEvent } from '@trackers';
function Meals(_a) {
    var onBack = _a.onBack, content = _a.content;
    return (_jsxs("div", __assign({ className: "w-full flex flex-col justify-start items-start gap-sm-gutter" }, { children: [_jsx(NavigationLink, { label: "Our Meals", useIcon: true, direction: "left", onClick: onBack }), _jsx(MenuItemList, { menuItems: content.meals }), _jsx(Link, __assign({ to: "/meals", viewTransition: true, className: "hover:no-underline", onClick: function () {
                    return sendGoogleTagManagerEvent({ event: 'click-all_meals_to_listing', originName: 'navbar' });
                } }, { children: _jsx(Button, { label: "View All", use: "outline", size: "mini" }) }))] })));
}
export default Meals;
